document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-faq-wrapper]').forEach(function (wrapper) {
    if (wrapper.getAttribute('data-one-at-a-time') !== 'true') return;

    var items = wrapper.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  });
});